"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAskAnAgentState = void 0;
var AskAnAgentListState_init_1 = require("@/pages/askAnAgentList/states/AskAnAgentListState.init");
var NewsArticles_init_1 = require("@/pages/newsAndInsights/states/NewsArticles.init");
exports.defaultAskAnAgentState = {
    content: AskAnAgentListState_init_1.defaultAskAnAgentResults[0],
    related: AskAnAgentListState_init_1.defaultAskAnAgentResults,
    news: NewsArticles_init_1.defaultNewsArticles.items,
    t: {
        viewProfile: 'View Profile',
        relatedQuestions: 'Related Questions',
        propertyNews: 'Property News',
    },
};
